// @spec IAM-STR-003
import { Link, createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { z } from 'zod';

import { ResetPasswordForm } from '@/components/auth/reset-password-form';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const searchSchema = z.object({
  email: z.string().email().optional(),
});

export const Route = createFileRoute('/reset-password/')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    // Redirect to forgot-password if no email provided
    if (!search.email) {
      redirect({ to: '/forgot-password', throw: true });
    }
  },
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { email } = Route.useSearch();
  const navigate = useNavigate();

  const handleSuccess = () => {
    void navigate({ to: '/dashboard' });
  };

  // This check is redundant due to beforeLoad, but TypeScript needs it
  if (!email) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Check your email</CardTitle>
          <CardDescription>
            We sent a verification code to{' '}
            <span className="font-medium text-foreground">{email}</span>
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <ResetPasswordForm email={email} onSuccess={handleSuccess} />
          <div className="text-center">
            <Link
              to="/sign-in"
              className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to Sign In
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
